<template>
  <div
    :style="{
      'height': height,
      'width': width,
    }"
    class="google-maps"
  >
    <google-maps-loader
      :all-markers-in-view="false"
    >
      <template>
        <google-maps-data-layer
          :json="region"
          :downloadable="false"
        />
        <google-maps-info-window>
          <summary-counter />
        </google-maps-info-window>
      </template>
    </google-maps-loader>
  </div>
</template>

<script>
export default {
  name: 'GoogleMaps',

  props: {
    /**
     * The height of the Google Maps container
     */
    height: {
      type: String,
      required: false,
      default: '100%',
    },

    /**
     * The width of the Google Maps container
     */
    width: {
      type: String,
      required: false,
      default: 'auto',
    },

    /**
     * Should the info window close when click somewhere on the map<br />
     * `none` `close`
     */
    infoWindowClickOutside: {
      type: String,
      required: false,
      default: 'close',
      validator: (value) => ['none', 'close'].includes(value),
    },
  },

  computed: {
    region() {
      const apiUrl = './api';

      return `${apiUrl}/regions-2019.geojson`;
    },
  },

  methods: {
    showMarker(value, markerId) {
      this.$refs[markerId][0].$children[0].toggleMarker(value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .google-maps {
    max-height: 100%;
    max-width: 100%;
    position: relative;
  }
</style>
